// Flat style button

import styled from 'styled-components';
import {useCallback} from 'react';
import buttonKeyDownHandler from "../utils/button_keydown_handler";

export const DivButton = ({onClick, children, ...props}) => {
    const handleClick = useCallback((event) => {
        event.preventDefault();
        event.stopPropagation();
        if (typeof onClick === 'function') {
            onClick(event);
        }
    }, [onClick]);
    return (
        <div
            tabIndex="0"
            role="button"
            onClick={handleClick}
            onKeyDown={buttonKeyDownHandler}
            style={{cursor: 'pointer'}}
            {...props}
        >
            {children}
        </div>
    );
};

const BaseButton = styled(({ onClick, ...props }) => {
    const handleClick = useCallback((event) => {
        event.preventDefault();
        event.stopPropagation();
        if (typeof onClick === 'function') {
            onClick(event);
        }
    }, [onClick]);
    return <button type="button" onClick={handleClick} {...props} />;
})`
  font-family: inherit;
  font-size: 100%;
  line-height: normal;
  margin: 0;
  border: 0;
  overflow: visible;
  text-transform: none;
  -webkit-appearance: button;
  text-align: center;
  cursor: pointer;
  box-shadow: none;
`;

export const BareButton = styled(BaseButton)`
  color: inherit;
  background-color: inherit;
`;

export const TextButton = styled(BareButton)`
  display: inline;
  -webkit-appearance: none;
`;

const StyledButton = (Button) => styled(Button)`
  ${({theme}) => `
    color: ${theme.control.color};
    background-color: ${theme.control.backgroundColor};
    padding: 6px 12px;
    border-radius: 6px;
  `}
`;

export const SubmitButton = StyledButton((props) => <button type="submit" {...props} />);

const Button = StyledButton(BareButton);

export default Button;
